import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { AffiliatesLink } from './AffiliatesLink';

interface FaqProps {
  variant: 'footer' | 'header' | 'subitem';
}

export const Faq = ({ variant }: FaqProps) => (
  <AffiliatesLink variant={variant} path="/faq" category={'FAQ'}>
    <I18n k="affiliates_signup_perseus.affiliates.faq" />
  </AffiliatesLink>
);
